import { useEffect } from 'react';
import { useStore } from 'client/pc/store';
import { store as giftBottom } from 'widgets/functions/gift/store/gift-bottom';
import gift from 'modules/widgets/functions/gift/gift';
import assign from 'lodash/assign';

/**
 * 个播 与 多人pk模式切换时，送礼栏用户列表对应切换
 */
const useUserList = () => {
  const { starInfo } = useStore().room;

  useEffect(() => {
    // 个播房间的
    giftBottom.updateUserList([]);
    giftBottom.addUser({
      uid: starInfo._id,
      name: starInfo.nick_name,
    });
    gift.event.onBeforeSend = (data) => {
      return data;
    };
  }, []);
};

export default {
  useUserList,
};
